import { createClient } from "postchain-client";
import { store } from "../../store/store";
import { TypedGtxClient, iChrAsset, iChrClientInfo, iChrParams, iChrVault } from "../interfaces/chromiaInterfaces";
import { iClientInfo, iHedgerInfo, iPeriod } from "../interfaces/interfaces";
import { appActionTypes } from "../../store/app/appTypes";
import { Token } from "../../entities/Token";
import { BigNumber } from "../../entities/BigNumber";
import { getVaultInfoBN } from "./app";



export const getGtxClient = async (): Promise<TypedGtxClient> => {
	const { gtxClient } = store.getState().app;
	
	if (gtxClient) return gtxClient;

	// const directoryNodeUrlPool = [
	// 	"https://node4.devnet1.chromia.dev:7740",
	// 	"https://node5.devnet1.chromia.dev:7740",
	// 	"https://node6.devnet1.chromia.dev:7740",
	// ];

	const directoryNodeUrlPool = [
		"https://node0.questnet.chromia.dev:7740",
		"https://node1.questnet.chromia.dev:7740",
		"https://node2.questnet.chromia.dev:7740",
		"https://node3.questnet.chromia.dev:7740"
		// "https://node7.devnet1.chromia.dev:7740",
	];

	// const rid = await (await fetch(`${chromiaBlockchainUrl}brid/iid_0`)).text();

	const newGtxClient = (await createClient({
		directoryNodeUrlPool,
		blockchainRid: process.env.REACT_APP_CHROMIA_BLOCKCHAIN_RID,
	})) as TypedGtxClient;
	
	store.dispatch({
		type: appActionTypes.SET_GTX_CLIENT,
		payload: newGtxClient
	})

	return newGtxClient;
}


export async function getHedgerHistReq() {
	const { chrClientAddr } = store.getState().app;

	if (chrClientAddr && process.env.REACT_APP_ITEM_ID) {
		const res = (await getGtxClient()).query("moxio.GetAllHistHReqsByItemAndAcc", {
			item_id: process.env.REACT_APP_ITEM_ID,
			acc_id: chrClientAddr,
		})
		return res
	}
}
export function getChromiaToken(address: string, decimals: number, name: string, symbol?: string): Token {
    const { tokens } = store.getState().app;

	const foundToken = tokens.find(token => token.address.toLocaleLowerCase() === address.toLocaleLowerCase());

	if (foundToken) return foundToken;
	
	// const configToken = getConfigToken({type: 'token', address: params.address});
	const newToken = new Token(1, address, decimals, name, symbol);
	store.dispatch({
		type: appActionTypes.ADD_TOKEN,
		payload: newToken
	})
	return newToken;
}

export const updateChromiaBalances = async () => {
	const { chrClientAddr } = store.getState().app;

	if (chrClientAddr) {
		const res = (await getGtxClient()).query("ft4.get_asset_balances", {
			account_id: chrClientAddr,
			page_size: 100,
			page_cursor: null
		})
		return await res
	}
}

export function dispatchChromiaBalances(res: {amount: BigInt; asset: iChrAsset}[]) {
	const { ltVault, stVault, params } = store.getState().app;

	if (res && ltVault && stVault) {
		const ltBalance = res.find((balance) => balance.asset.id.toString("hex").toLocaleLowerCase() === ltVault?.tok);
		const stBalance = res.find((balance) => balance.asset.id.toString("hex").toLocaleLowerCase() === stVault?.tok);
		const ftBalance = res.find((balance) => balance.asset.id.toString("hex").toLocaleLowerCase() === params?.ft.toString('hex'));
	
		const balances = {
			lt: (ltBalance && new BigNumber(ltBalance?.amount.toString(), {currentDecimals: +ltBalance?.asset.decimals, decimals: +ltBalance?.asset.decimals})) || new BigNumber(0),
			st: (stBalance && new BigNumber(stBalance?.amount.toString(), {currentDecimals: +stBalance?.asset.decimals, decimals: +stBalance?.asset.decimals})) || new BigNumber(0),
			ft: (ftBalance && new BigNumber(ftBalance?.amount.toString(), {currentDecimals: +ftBalance?.asset.decimals, decimals: +ftBalance?.asset.decimals})) || new BigNumber(0)
		}
			
		store.dispatch({
			type: appActionTypes.SET_BALANCES,
			payload: balances
		})
	}
}

export function dispatchFtToken() {
	const {params, tokens } = store.getState().app;


	const ftToken = tokens.find(token => token.address.toLocaleLowerCase() === params?.ft.toString('hex'));

	if (ftToken) {
		store.dispatch({
			type: appActionTypes.SET_TOKEN,
			payload: ftToken?.name
		})
	}
}

export const getParams = async () => {

	if (!process.env.REACT_APP_ITEM_ID) throw new Error('no item id')
	const params = (await getGtxClient()).query("moxio.GetItem", { item_id: process.env.REACT_APP_ITEM_ID });

	return params
}

export function dispatchParams(params: iChrParams) {
	store.dispatch({
		type: appActionTypes.SET_PARAMS,
		payload: params
	})
}

export const getClientInfo = async () => {
	const { chrClientAddr } = store.getState().app;

	if (chrClientAddr && process.env.REACT_APP_ITEM_ID) {
		const clientInfo = (await getGtxClient()).query("moxio.GetCReqsByItemAndAcc", { item_id: process.env.REACT_APP_ITEM_ID, acc_id: chrClientAddr});

		return clientInfo
	}
}

export function dispatchClientInfo(clientInfo: iChrClientInfo[]) {
	
	if (clientInfo) {
		const clientInfoObj: iClientInfo = {} as iClientInfo;

		clientInfo.forEach((req) => {
			clientInfoObj[req.type] = {
				...req, 
				amt: new BigNumber(req.amt_dec, {decimals: 18})
			};
		});

		store.dispatch({
			type: appActionTypes.SET_CLIENT_INFO,
			payload: clientInfoObj
		})
	}
	else {
		store.dispatch({
			type: appActionTypes.SET_CLIENT_INFO,
			payload: null
		})
	}

}

export const getVaults = async () => {
	if (process.env.REACT_APP_ITEM_ID) {
		const res =  (await getGtxClient()).query("moxio.GetVaults", { item_id: process.env.REACT_APP_ITEM_ID });
		return res
	}
}

export function dispatchVaults(res: iChrVault[]) {
	
	const ltvInfo = res.find((vault) => vault.name === 'ltv');
	const stvInfo = res.find((vault) => vault.name === 'stv');
	
	if (stvInfo && ltvInfo) {
		const ltvInfoBN = getVaultInfoBN(ltvInfo);
		const stvInfoBN = getVaultInfoBN(stvInfo);
		
		store.dispatch({
			type: appActionTypes.SET_LT_VAULT,
			payload: ltvInfoBN
		})
	
		store.dispatch({
			type: appActionTypes.SET_ST_VAULT,
			payload: stvInfoBN
		})
	}
}

export const getPeriods = async () => {
	if (!process.env.REACT_APP_ITEM_ID) throw new Error('no item id');

	const periods = await (await getGtxClient()).query("moxio.GetPeriods", { item_id: process.env.REACT_APP_ITEM_ID });
	
	if (!periods)
		throw new Error('cant get periods')

	return periods
}

export function dispatchPeriods(periods: iPeriod[]) {
	store.dispatch({
		type: appActionTypes.SET_PERIODS,
		payload: periods
	})
}

export const getCurrTime = async () => {
	const currTime = await (await getGtxClient()).query("moxio.GetTime", { });
	
	if (!currTime)
		throw new Error('cant get current time')

	return currTime
}

export const setTime = async (time: number) => {
	(await getGtxClient()).sendTransaction({name: "SetTime", args: [time]})
}

export async function getHedgerRequests() {
	const { chrClientAddr } = store.getState().app;

	if (chrClientAddr && process.env.REACT_APP_ITEM_ID) {
		const hedgerRequests = await (await getGtxClient()).query("moxio.GetHReqByItemAndAcc", { item_id: process.env.REACT_APP_ITEM_ID, acc_id: chrClientAddr});

		const hedgerRequestsBN: iHedgerInfo[] = hedgerRequests.map((request) => {
			return {
				...request,
				fee_amt: new BigNumber(request.fee_amt_dec),
				use_ft: new BigNumber(request.use_ft_dec),
				req_ft: new BigNumber(request.req_ft_dec)
			}
		})

		return hedgerRequestsBN
	}
}